import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const FeedbackWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const FeedbackContents = styled.div`
  width: 100%;
  max-width: 900px;
`

const FeedbackImage = styled.div`
  max-height: 900px;
  margin: 0px auto;
  margin-top: 1em;
  display: inline-block;
  img {
    max-width: 100%;
    height: auto;
    max-height: 50vh;
    margin-bottom: 1em;
  }
`

const FeedbackEmbed = styled.div`
  max-height: 900px;
  margin: 0px auto;
  display: inline-block;
  margin-top: 1em;
  iframe {
    max-width: 100%;
    margin-bottom: 1em;
  }
`

const FeedbackText = styled.div`
  font-size: 1.3em;
  @media (min-width: 768px) {
    font-size: 1.6em;
  }
  max-width: 900px;
  margin: 0px auto;
  text-align: left;
  display: flex;
  align-items: center;
  margin-top: 1em;
  svg {
    font-size: 3em;
    @media (min-width: 768px) {
      font-size: 4em;
    }
    margin-right: -15px;
    opacity: .2;
  }
`

const FeedbackLink = styled.div`
  text-align: right;
  margin-top: 1em;
`

export default class Feedback extends React.Component {
  static propTypes = {
    feedback: PropTypes.object.isRequired
  }

  static defaultProps = {
    feedback: {}
  }


  render() {
    let {
      feedback_text, feedback_image_url, feedback_embed, feedback_url
    } = this.props.feedback
    let { hideQuestionFeedback } = this.props

    return (
      <FeedbackWrapper>
        { /* feedback_text should always be present, set in quiz_attempt_question */ }
        {
          hideQuestionFeedback
            ? null
            : (<FeedbackText><i className="fad fa-bullseye-pointer"></i> { feedback_text }</FeedbackText>)
        }

        <div>
          { this.props.children }
        </div>

        {
          hideQuestionFeedback
            ? null
            : (
              <FeedbackContents>
                {
                  feedback_image_url
                    ? (
                      <FeedbackImage>
                        <img src={feedback_image_url} alt='question-image'/>
                      </FeedbackImage>
                    )
                    : null
                }

                {
                  feedback_embed
                    ? (
                      <FeedbackEmbed>
                        <div dangerouslySetInnerHTML={{ __html: feedback_embed }}/>
                      </FeedbackEmbed>
                    )
                    : null
                }

                {
                  feedback_url
                    ? (
                      <FeedbackLink>
                        <a
                          className='btn btn-default'
                          href={ feedback_url }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          More Info
                        </a>
                      </FeedbackLink>

                    )
                    : null
                }
              </FeedbackContents>
            )
        }
      </FeedbackWrapper>
    )
  }
}
